import DropdownOption from "@/entities/DropdownOption";
import ProfileCountries from "@/entities/locationEntities/ProfileCountries";

const onlyPrimaryCountries = (countries: DropdownOption[]) =>
  [ProfileCountries.USA, ProfileCountries.CANADA].every(country => countries.some(c => c.name === country));

export default onlyPrimaryCountries;